export const locale = {
    lang: 'de',
    data: {
      'EDITOR': {
        'CARGANDO': 'Informationen laden',
        'GUARDANDO': 'Änderungen speichern',
        'ELEMENTOS': {
          'GUIA': 'Elemente dieses Blocks',
          'COLORES': {
            'ORIGINAL': 'Unverändertes Element',
            'MODIFICADO': 'Geänderter Artikel'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Es wurde kein Element geändert',
            'MODIFICADO': 'Ein oder mehrere Elemente wurden geändert',
            'COMPLETO': 'Alle Elemente wurden geändert',
            'AMPLIAR': 'Ansicht in großer Größe',
            'ELIMINAR': 'Löschen Sie dieses Bild',
            'IMPORTAR': 'Importieren Sie diesen Artikel aus einer anderen Sprache',
            'CONFIGDOMINIO': 'Konfiguration der Backend-Domäne',
            'COPIARURL': 'Link kopieren'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': 'Konfiguration durch Broker',
              'SUBTITULO': 'Sie können die Einstellungen jedes verfügbaren Brokers anzeigen und ändern',
              'PASOINICIAL': 'Wählen Sie einen Broker aus der Liste aus, um dessen Konfiguration anzuzeigen',
              'SELBROKER': 'Ausgewählter Broker',
              'SELOPC': 'Ausgewählte Option',
              'SINJSONS': 'Fehler beim Laden der Informationen von diesem Broker, versuchen Sie es später',
              'DOMINIO': {
                'TITULO': 'Broker-Backend-Domänenkonfiguration',
                'ACTIVAR': 'Aktivieren Sie die dem Broker zugeordnete Domain',
                'DOMINIO': 'Mit dem Broker verknüpfte Domain'
              },
              'MODAL': {
                'TITULO': 'Element importieren',
                'SUBTITULO': 'Wählen Sie die Sprache aus, aus der Sie dieses Element importieren möchten'
              }
            },
            'IMAGEN': {
              'NOHAY': 'Es gibt kein Bild',
              'ACTUAL': 'Aktuelles Bild'
            },
            'TEXTO': {
              'INGRESAR': 'Geben Sie Ihren Text ein'
            },
            'VIDEO': {
              'NOVIDEO': 'Sie haben kein Video hochgeladen',
              'GUARDANDO': 'Wenn Sie ein Video speichern, verlassen Sie diesen Bildschirm erst, wenn der Upload abgeschlossen ist'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Umfrageeigenschaften bearbeiten',
            'REGRESAR': 'Geh zurück',
            'CONTINUAR': 'Fortsetzen',
            'CANCELAR': 'Stornieren',
            'GUARDAR': 'Änderungen speichern',
            'IMAGEN': 'Bild ändern',
            'EDITOR': 'Nachricht bearbeiten',
            'ELEMENTOS': 'Hilfe',
            'ACTIVAR': 'Show',
            'DESACTIVAR': 'Ausblenden',
            'VERVIDEO': 'Schau Video',
            'CARGARVIDEO': 'Videodatei hochladen',
            'OTROVIDEO': 'Laden Sie eine andere Videodatei hoch',
            'SI': 'Ja',
            'NO': 'Nein',
            'INFO': 'Wichtig',
            'ADDIMG': 'Bild hinzufügen'
          },
          'MODALIMAGEN': {
            'TITULO': 'Bild zur Nachricht hinzufügen',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': 'Anleitung',
                'PASO_1': 'Klicken Sie auf die Registerkarte \'Bilder\', dort können Sie ein bereits hochgeladenes Bild auswählen oder auch ein neues Bild hochladen',
                'PASO_2': 'Wenn Sie ein bereits hochgeladenes Bild auswählen möchten, können Sie zwei Aktionen ausführen, indem Sie den Cursor auf das gewünschte Bild setzen: Sehen Sie sich das Bild an oder kopieren Sie den Link',
                'PASO_2_1': 'Um eine Vorschau anzuzeigen, klicken Sie auf die Schaltfläche neben der Schaltfläche auf dem Bild mit dem folgenden Symbol',
                'PASO_2_2': 'Um den Link zu kopieren, klicken Sie auf die Schaltfläche auf die Schaltfläche auf dem Bild mit dem folgenden Symbol',
                'PASO_3': 'Wenn Sie ein neues Bild hochladen möchten, klicken Sie auf die Schaltfläche mit dem folgenden Symbol',
                'PASO_4': 'Wenn Sie das Bild hochgeladen haben, erhalten Sie automatisch den Link automatically',
                'PASO_5': 'Gehen Sie zurück zum Nachrichteneditor und klicken Sie auf die Schaltfläche, um ein Bild mit dem folgenden Symbol einzufügen',
                'PASO_6': 'Platzieren Sie im Popup-Fenster den kopierten Link und legen Sie die Bildgröße in Pixeln fest. Wenn Sie fertig sind, klicken Sie auf die Schaltfläche Speichern. Das Popup-Fenster wird geschlossen und das Bild wird mit der eingestellten Größe im Editor platziert'
              },
              'IMAGENES': {
                'TITULO': 'Bilder',
                'CARGANDO': 'Verfügbare Bilder werden geladen',
                'NOTA': '* Die hier gezeigten Bilder werden im Dateimanager gespeichert',
                'TITULO_2': 'Verfügbare Bilder',
                'ADD': 'Neues Bild hinzufügen',
                'NOIMG': 'Keine Bilder verfügbar',
                'URLCOPIADA': 'Bildlink in Zwischenablage kopiert',
                'OKBOT': 'OK'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': 'Farbset 1',
            'theme-temaIzzi': 'Farbset 2',
            'theme-blue-gray-dark': 'Farbset 3',
            'theme-pink-dark': 'Farbset 4',
            'theme-temaIzzi-2': 'Farbset 5',
            'theme-temaItbm': 'Farbset 6',
          },
          'numColumnas': {
            '1': '1 Spalten',
            '4': '4 Spalten',
            '5': '5 Spalten',
          },
          'segundos': {
            '1000': '1 Sekunde',
            '2000': '2 Sekunden',
            '3000': '3 Sekunden',
            '4000': '4 Sekunden',
            '5000': '5 Sekunden',
            '6000': '6 Sekunden',
            '7000': '7 Sekunden',
            '8000': '8 Sekunden',
            '9000': '9 Sekunden',
            '10000': '10 Sekunden',
            '11000': '11 Sekunden',
            '12000': '12 Sekunden',
            '13000': '13 Sekunden',
            '14000': '14 Sekunden',
            '15000': '15 Sekunden',
            '16000': '16 Sekunden',
            '17000': '17 Sekunden',
            '18000': '18 Sekunden',
            '19000': '19 Sekunden',
            '20000': '20 Sekunden',
          },
          'logosIniciales': {
            '0': 'CulturalGO-Logo'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': 'Warnung: Wenn die Quellwebsite keinen Zugriff von externen Websites auf die Seite zulässt, wird der Inhalt nicht angezeigt',
          'TEMPLATEFALTANTE': 'Warnung: Diese Vorlage ist für diese Sprache nicht verfügbar',
          'CONFIGURACION': {
            'ACTIVAR': 'Achtung: Wenn Sie die benutzerdefinierte Konfiguration aktivieren, werden alle auf diesem Bildschirm angegebenen Elemente in der Plattformoberfläche platziert. Stellen Sie sicher, dass Sie alle richtigen Elemente platziert haben. \n\n Möchten Sie fortfahren und die benutzerdefinierte Konfiguration aktivieren?',
            'DESACTIVAR': 'Achtung: Beim Deaktivieren der benutzerdefinierten Konfiguration werden die in der Plattform für diesen Broker und für alle dazugehörigen Benutzer festgelegten Standardelemente platziert. \n\n Möchten Sie die personalisierte Konfiguration fortsetzen und deaktivieren? '
          },
          'PRIORIDAD': {
            '1': 'Wenn dieses Element aktiv ist, wird den Hintergrundbildern Vorrang eingeräumt',
            '2': 'Wenn dieses Element aktiv ist, haben die Hintergrundbilder und der Videohintergrund Vorrang.'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Anmeldung',
            'PASOS': {
              'VARIOS': {
                'TITULO': 'Sonstige Gegenstände',
                'ELEMENTOS': {
                  'images_broker': 'Broker-Logo',
                  'title': 'Überschrift',
                  'images_login': 'Systemlogo',
                  'images_logout': 'Das Bild wird beim Abmelden angezeigt',
                  'changeTime': 'Zeitintervall zwischen Bildern'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Hintergrundbilder',
                'ELEMENTOS': {
                  'agregar': 'Fügen Sie ein Bild hinzu',
                  'importar': 'Importieren Sie Bilder aus anderen Einstellungen',
                }
              },
              'VIDEO': {
                'TITULO': 'Hintergrundvideo',
                'ELEMENTOS': {
                  'enable': 'Hintergrundvideo aktivieren',
                  'video': 'Video zu zeigen',
                  'loop': 'Aktivieren Sie die automatische Wiederholung',
                  'mute': 'Stummgeschaltetes Video anzeigen'
                }
              },
              'EXTERNO': {
                'TITULO': 'Externer Inhalt',
                'ELEMENTOS': {
                  'enable': 'Externen Inhalt aktivieren',
                  'url': 'Link zum Anzeigen externer Inhalte',
                }
              }
            }
          },
          'HOME': {
            'TITULO': 'Startseite',
            'PASOS': {
              'BRAND':{
                'TITULO': 'Systemidentität im Seitenmenü',
                'ELEMENTOS': {
                  'logo': 'Systemlogo',
                  'name': 'Systemname'
                }
              },
              'LOGOINICIAL': {
                'TITULO': 'Ursprüngliches Logo',
                'ELEMENTOS': {
                  'show': 'Erstes Systemlogo anzeigen',
                  'time': 'Anzeigezeit des Logos (ausgedrückt in Sekunden)',
                  'type': 'Anfänglicher Logotyp, der angezeigt werden soll'
                }
              },
              'MOSAICO': {
                'TITULO': 'Mosaik der Bilder',
                'ELEMENTOS': {
                  'branding_show': 'Systemmarkenlogo anzeigen',
                  'branding_image': 'Systemmarkenlogo',
                  'grayFilter': 'Graufilter bei Startbildern',
                  'bgGridColumns': 'Anzahl der anzuzeigenden Bildspalten'
                }
              },
              'TEMAS': {
                'TITULO': 'Plattformfarbthema',
                'ELEMENTOS': {
                  'theme': 'Farbthema, das im System angezeigt werden soll'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Hintergrundbilder',
                'ELEMENTOS': {
                  'agregar': 'Fügen Sie ein Bild hinzu',
                  'importar': 'Importieren Sie Bilder aus anderen Einstellungen',
                }
              },
              'VIDEO': {
                'TITULO': 'Hintergrundvideo',
                'ELEMENTOS': {
                  'enable': 'Hintergrundvideo aktivieren',
                  'video': 'Video zu zeigen',
                  'loop': 'Aktivieren Sie die automatische Wiederholung',
                  'mute': 'Stummgeschaltetes Video anzeigen'
                }
              },
              'EXTERNO': {
                'TITULO': 'Externer Inhalt',
                'ELEMENTOS': {
                  'enable': 'Externen Inhalt aktivieren',
                  'url': 'Link zum Anzeigen externer Inhalte',
                }
              },
              'LOADER': {
                'TITULO': 'Bild .gif wird geladen',
                'ELEMENTOS': {
                  'image': 'Bild wird geladen .gif',
                  'GUARDANDO': 'Bild wird gespeichert, verlassen Sie diesen Bildschirm nicht, bevor das Laden abgeschlossen ist'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': 'E-Mail-Vorlagen',
            'PASOS': {
              'RT_1': {
                'TITULO': 'Technische Anforderungen, die bei der Registrierung eines neuen Produkts gesendet werden',
                'ELEMENTOS': {
                  'asunto': 'Betreff der Nachricht',
                  'mensaje': 'Nachrichtentext'
                }
              },
              'RT_2': {
                'TITULO': 'Technische Anforderungen, Demo-Nachricht während der Validierung gesendet',
                'ELEMENTOS': {
                  'asunto': 'Betreff der Nachricht',
                  'mensaje': 'Nachrichtentext'
                }
              },
              'PASS_3': {
                'TITULO': 'E-Mail gesendet, wenn das Benutzerkennwort aktualisiert wird',
                'ELEMENTOS': {
                  'asunto': 'Betreff der Nachricht',
                  'mensaje': 'Nachrichtentext'
                }
              },
              'PASS_4': {
                'TITULO': 'E-Mail gesendet, wenn das Benutzerprofil aktualisiert wird',
                'ELEMENTOS': {
                  'asunto': 'Betreff der Nachricht',
                  'mensaje': 'Nachrichtentext'
                }
              },
              'GETMYCODE_6': {
                'TITULO': 'Mail gesendet mit GetMyCode',
                'ELEMENTOS': {
                  'asunto': 'Betreff der Nachricht',
                  'mensaje': 'Nachrichtentext'
                }
              },
              'RT_7': {
                'TITULO': 'Mail zur Annahme der technischen Voraussetzungen',
                'ELEMENTOS': {
                  'asunto': 'Betreff der Nachricht',
                  'mensaje': 'Nachrichtentext'
                }
              },
            }
          }
        }
      }
    }
};
